module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/盛泰制造.81439afe.svg";